import script from "./UserStatsCardsComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./UserStatsCardsComponent.vue?vue&type=script&setup=true&lang=js"

import "./UserStatsCardsComponent.vue?vue&type=style&index=0&id=1657534a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1657534a"]])

export default __exports__